import LogRocket from "logrocket";
import { useEffect, useState } from "react";
import AppRoutes from "./Routes";
import { logrocket as lrconfig } from "./config";
import { useAuth } from "./contexts/AuthContext";

function App() {
  const { apiUser } = useAuth();
  const [lrInit, setLrInit] = useState(false);

  useEffect(() => {
    if (lrconfig !== undefined) {
      LogRocket.init(lrconfig, {
        network: {
          requestSanitizer: (request) => {
            //request.body = null;
            return request;
          },
        },
      });
      setLrInit(true);
    }
  }, []);

  useEffect(() => {
    if (lrconfig !== undefined && apiUser && lrInit) {
      LogRocket.identify(apiUser.email, {
        name: `${apiUser.first_name} ${apiUser.last_name}`,
        // Add your own custom user variables here, ie:
        email: apiUser.email,
      });
    }
  }, [lrInit, apiUser]);

  return <AppRoutes />;
}

export default App;
